module.exports = __webpack_public_path__ + "img/nuage.636b15bf.svg";